import {useMutation, useQueryClient} from '@tanstack/react-query'

import {DM_SERVICE_HEADERS} from '#/lib/constants'
import {logger} from '#/logger'
import {
  type ConvoRequestListQueryData,
  optimisticDeleteJoinRequest,
  RQKEY_ROOT as REQUESTS_RQKEY_ROOT,
} from '#/state/queries/messages/list-conversation-requests'
import {useAgent, useSession} from '#/state/session'

export function useWithdrawJoinGroupChatRequest({
  onSuccess,
  onError,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSuccess?: (data: any) => void
  onError?: (error: Error) => void
} = {}) {
  const agent = useAgent()
  const queryClient = useQueryClient()
  const {hasSession} = useSession()

  return useMutation({
    mutationFn: async ({convoId}: {convoId: string}) => {
      if (!hasSession)
        throw new Error('Must be logged in to withdraw a join request')
      if (!convoId) throw new Error('No convoId provided')

      const res = await agent.chat._client.call(
        'chat.bsky.group.withdrawJoinRequest',
        {convoId},
        undefined,
        {headers: DM_SERVICE_HEADERS},
      )
      // TODO: type properly when @atproto/api exposes chat.bsky.group.withdrawJoinRequest schema
      return res.data as Record<string, unknown>
    },
    onSuccess: (data, {convoId}) => {
      queryClient.setQueriesData<ConvoRequestListQueryData>(
        {queryKey: [REQUESTS_RQKEY_ROOT]},
        old => optimisticDeleteJoinRequest(convoId, old),
      )
      onSuccess?.(data)
    },
    onError: error => {
      logger.error('Failed to withdraw join request', {safeMessage: error})
      onError?.(error)
    },
  })
}
